import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Accès standup / équipe interne Qolaig (domaine messagerie uniquement). */
export function isQolaigEmail(email: string | null | undefined): boolean {
  if (!email || typeof email !== "string") return false
  return email.trim().toLowerCase().endsWith("@qolaig.com")
}

